import React, { Fragment } from "react";
import { cloneDeep } from "lodash";


import { changesMadeToUnderEditImageData } from "../../utils/changesMadeToUnderEditImageData";
import { colors, ButtonGhostCompact, ButtonPrimaryCompact, ButtonSecondaryCompact  } from "oolib";

/**
 * fiddle for dealing with rotation: https://jsfiddle.net/wunderbart/w1hw5kv1/
 */

export function EditToolbar({
  setUnderEditImageData,
  underEditImageData,
  imageData,
  handleSingleImageDataChange,
  setImageUnderEdit, //comes from ImageInput context if used inside it
  imageSpread,
  publicUrl,
  defaultImageSpread,
  omitEditorTools
}) {
  
  return (
    <div
      style={{
        width: "100%",
        padding: "0.5rem",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: colors.black_opacity80,
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        { !omitEditorTools.includes('cover_contain') &&
          <ButtonGhostCompact
          invert
          
          iconSize="M"
          onClick={() =>
            setUnderEditImageData((prev) => {
              let spreadToSet = imageSpread === "cover" ? "contain" : "cover";
              return {
                ...prev,
                imageSpread: spreadToSet,
                ...(spreadToSet === "contain" ? { cropX: 0, cropY: 0 } : {}),
              };
            })
          }
          icon={imageSpread === "cover" ? "ArrowsIn" : "ArrowsOut"}
        />}

        {!omitEditorTools.includes('rotate') &&
          <ButtonGhostCompact
          invert
          icon="ArrowsClockwise"
          iconSize="M"
          
          onClick={() => {
            setUnderEditImageData((prev) => ({
              ...prev,
              imageRotate: ((prev.imageRotate || 0) + 90) % 360,
            }));
          }}
        />}
      </div>
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        {changesMadeToUnderEditImageData({
          imageData,
          underEditImageData,
          defaultImageSpread,
        }) && (
          <Fragment>
            <ButtonSecondaryCompact
              invert
              
              onClick={() => {
                setUnderEditImageData(cloneDeep(imageData));
              }}
            >
              Revert
            </ButtonSecondaryCompact>
            <ButtonPrimaryCompact
              invert
              
              onClick={() => {
                handleSingleImageDataChange({
                  publicUrl,
                  imageData: {
                    ...underEditImageData,
                    caption: imageData.caption //cuz caption edits are made directly to imageData and we dont want underEditImageData to overwrite that.
                  }, 
                });

                setUnderEditImageData(undefined);
                setImageUnderEdit && setImageUnderEdit(false);
              }}
            >
              Save
            </ButtonPrimaryCompact>
          </Fragment>
        )}

        <ButtonGhostCompact
          invert
          icon="X"
          
          onClick={() => {
            setUnderEditImageData(undefined);
          }}
        />
      </div>
    </div>
  );
}
